<template>
    <div>
        <b-modal no-stacking
            v-model="cod.isShow"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            size="lg"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-0">กรุณาเลือกบริการขนส่งเก็บเงินปลายทาง <small>( COD )</small></h3>
                        </div>
                    </div>
                </div>
            </template>
            <div class="container-fluid pb-5 pos card-courier">
                <div class="row">
                    <div class="col-12 col-lg-6 col-xl-3 mb-3"
                        v-for="courier in filterCourierCod"
                        :key="courier.id" >

                        <CardPos :courier="courier" @click.native="modalIdentity( courier )" />
                        <!-- @click.native="openModal(courier,'')" -->
                    </div>
                </div>
            </div>
            <div class="text-center m-4">
                <b-button variant="danger" block @click="handleShow()">ยกเลิก</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import CardPos from "@/components/CardPos"
import { COURIERS_COD }from '@/constants/CourierCOD'
export default {
    name: "CodCourierList" ,
    components: {
        CardPos
    },
    props: {
        sender: [Object],
        cod: Object ,
        func: Function,
        checkVerifyMemberCod: Function
    },
    data() {
        return {
            couriersCOD: COURIERS_COD
        }
    },
    methods: {
       async modalIdentity( courier ){
            this.cod.isCod = true
            this.handleShow()
            if (this.sender.name !== "") {
                await this.checkVerifyMemberCod()
                // console.log('doing something')
            }
            this.func( courier , '' )
        },
        handleShow(){
            this.cod.isShow = !this.cod.isShow
        }
    },
    computed: {
        filterCourierCod(){
            let courier = []
            if( this.cod.isShow === true ){
                courier = this.cod.couriers.filter( item => {
                    // item.title = item.title+' เก็บเงินปลายทาง'
                    return COURIERS_COD.couriers.indexOf(item.key) > -1 && item.prebarcode == 0
                })
            }
            return courier
        }
    }
}
</script>
<style scoped>
.pos.card-courier{
    padding-top: 0rem;
}
</style>